import { MsgBox, Vue } from '../../app.vues';

import SwbTradeDetail from './TradeDetail';
import SwbTradeVoucherAdd from './TradeVoucherAdd';

Vue.regist(SwbTradeDetail);
Vue.regist(SwbTradeVoucherAdd);

export function openTradeVoucherAddDlg(params, callback) {
    //
    let theDlg = Vue.$showDialog({
        title: '交易单 - 新增',
        width: 800,
        height: 900,
        showCloseBtn: true,
        template: '<div class = "">' +
        '<swb-trade-voucher-add :workVoucherIdList="workVoucherIdList" :proofIdList="proofIdList" :servicerId="servicerId" :servicerName="servicerName" :amount="amount" :servcType="servcType" :propFlag="propFlag" ref="swb_trade_voucher_add"></swb-trade-voucher-add>' +
        '</div>',
        data: {
            proofIdList: params.proofIdList,
            workVoucherIdList: params.workVoucherIdList,
            servicerId: params.servicerId,
            servicerName: params.servicerName,
            amount: params.amount,
            servcType: params.servcType,
            propFlag: true,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_trade_voucher_add.getDlgResult();
            if(result != null) {
                if(result.type == 'info') {
                    let tradeVoucher = result.data;
                    //
                    callback(tradeVoucher, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

export function openTradeVoucherDtoDlg(tradeId, tradeFlag, trackPhaseId, callback) {
    //
    Vue.$showDialog({
        title: '交易数据 - 详情',
        width: -160,
        height: -160,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-trade-voucher-dto-detail :tradeId="tradeId" :tradeFlag="tradeFlag" :trackPhaseId="trackPhaseId" ref="swb_servc_work_voucher_dto_detail"></swb-trade-voucher-dto-detail>' +
        '</div>',
        data: {
            tradeId: tradeId,
            tradeFlag: tradeFlag,
            trackPhaseId: trackPhaseId
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/tradeVoucher/showDlg.js
// module id = 251
// module chunks = 0